import React, { Component } from 'react'
import { observer } from 'mobx-react'

import TasksTable from '../taskstable'

@observer(['globals', 'tasks'])
export default class CompanyTasksTable extends Component {
  constructor(props) {
    super(props)
  }

  onLoadTask(id, callback) {
    this.props.tasks.loadTask(id, (data) => {
      let dd = new Date(data.dueDate)
      let dateString = dd.getUTCFullYear() + '-' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2)

      const loadedTask = {
        id: id,
        companyId: data.companyId,
        taskPriorityId: data.taskPriorityId,
        taskStateId: data.taskStateId,
        task: data.task,
        companyPhone: data.company.defaultContact.phone,
        companyEmail: data.company.defaultContact.email,
        assignedUserId: data.assignedUserId,
        assignedUserName: data.assignedUser.firstName + ' ' + data.assignedUser.lastName,
        formattedDueDate: dateString
      }

      if (callback) {
          callback(loadedTask)
      }
    })
  }

  onSaveTask(data, callback) {
    this.props.tasks.updateTask(data, () => {
      if (callback != null) {
        callback(data)
      }
    })
  }

  onDeleteTask(id, callback) {
    this.props.tasks.deleteTask(id, (data) => {
      this.reload()
    })
  }

  onMassDueDateSave(data, callback) {
    this.props.tasks.updateTaskDuedate(data, () => {
      if (callback != null) {
        callback()
      }
    })
  }

  onMassAssignedUserSave(data, callback) {
    this.props.tasks.updateTaskAssignedUser(data, () => {
      if (callback != null) {
        callback()
      }
    })
  }

  reload(callback) {
    this.props.reload(() => {
      if (callback != null) {
        callback()
      }
    })
  }

  render() {
    return (
      <div>
        <TasksTable data={ this.props.data } taskTypeHeading="Company" taskType="companyName" reload={ this.reload.bind(this) } onSaveTask={ this.onSaveTask.bind(this) } onDeleteTask={ this.onDeleteTask.bind(this) } onMassDueDateSave={ this.onMassDueDateSave.bind(this) } onMassAssignedUserSave={ this.onMassAssignedUserSave.bind(this) } onLoadTask={ this.onLoadTask.bind(this) } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tasks/companytaskstable.js